import { useEffect } from 'react'
import { useConnectionQualityIndicator, useLocalParticipant } from '@livekit/components-react'
import { ConnectionQuality } from 'livekit-client'

export enum ECallConnectionQuality {
  GOOD = 'good',
  MEDIUM = 'medium',
  POOR = 'poor'
}

const QUALITY_MAP: Partial<Record<ConnectionQuality, ECallConnectionQuality>> = {
  [ConnectionQuality.Excellent]: ECallConnectionQuality.GOOD,
  [ConnectionQuality.Good]: ECallConnectionQuality.MEDIUM,
  [ConnectionQuality.Poor]: ECallConnectionQuality.POOR,
  [ConnectionQuality.Lost]: ECallConnectionQuality.POOR
}

/**
 * Local participant connection quality. Has to be called inside a LiveKit room context.
 */
export const useConnectionQuality = (): ECallConnectionQuality => {
  const { localParticipant } = useLocalParticipant()
  const { quality } = useConnectionQualityIndicator({ participant: localParticipant })

  return QUALITY_MAP[quality] ?? ECallConnectionQuality.GOOD
}

export const useConnectionQualityReporter = (
  onChange?: (quality: ECallConnectionQuality) => void
) => {
  const quality = useConnectionQuality()

  useEffect(() => {
    onChange?.(quality)
  }, [quality, onChange])
}
